import React, {useContext} from "react";
import { useDispatch } from 'react-redux';
import {useNavigate} from 'react-router-dom';
import { useTranslation } from "react-i18next";
import alerticon from '../../assets/images/alerticon.png'; 
import popop_close from '../../assets/images/popop_close.png'; 
import CustomCurrencyFormat from '../utils/CurrencyFormat';
import { repeatOrder,cartFetch } from "../../features/cartSlice";
import { LoaderContext } from '../utils/Contexts';
import * as Config from '../../config/config';

function Orderdelivery(props) {
  const { t } = useTranslation();
  const {isActive, onClose} = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoader, setLoader } = useContext(LoaderContext);
  const deliveryDate = new Date(props.delivery_date); 
  let referenceNo = props.reference_no;
  if(props.invoice) {
    referenceNo = props.invoice_no;
  }
  const onProceed = () => {
    setLoader(true);
    dispatch(repeatOrder({
      order_id: props._id,
      customer_id: props.customer
    }));
    setTimeout(() => { 
      dispatch(cartFetch());
      setLoader(false);
      onClose(); 
      navigate(Config.CART);
    }, 1500);
  }
  
  return (

    <div className={`darkpopup ${isActive ? "active" : ""}`}>
          <div className="darkpopup_inner">
            <img className="popup_close" src={popop_close} onClick={onClose} alt="" width="43" height="43" />
            <img className="right_tick_popup" src={alerticon} alt="" width="81" height="81" />
            <p>{t('repeat_order_note')}</p>
            <div className="yesnobtn">
              <button className="whitebtn proceedbtn" onClick={onProceed}>{t('proceed')}</button>
              <button className="whitebtn cancelbtn" onClick={onClose}>{t('cancel')}</button>
            </div>
          </div>
        </div>

    );
}

export default Orderdelivery;
